import { isNone } from '@ember/utils';
import { assert } from '@ember/debug';
import { A } from '@ember/array';
// This string will be used in Ember.assert calls to alert developers that a call is missing. Therefore, it will not
// need to be translated.
const FETCH_ERROR = 'You must call fetchMerchantSubunits before you can access itemSubunits. Add it to a base route?';
let ITEM_SUBUNITS_SERVICE_ALL_FOR_MERCHANT_ACTIVE_SUBUNITS = [];
let ITEM_SUBUNITS_SERVICE_AUTHORIZED_ACTIVE_SUBUNITS = [];
let ITEM_SUBUNITS_SERVICE_ALL_FOR_MERCHANT_INACTIVE_SUBUNITS = [];
let ITEM_SUBUNITS_SERVICE_AUTHORIZED_INACTIVE_SUBUNITS = [];
let HAS_FETCHED = false;
export function itemSubunitsServiceActiveSubunits(allForMerchant = false) {
  assert(FETCH_ERROR, HAS_FETCHED);
  if (allForMerchant) {
    return A([...ITEM_SUBUNITS_SERVICE_ALL_FOR_MERCHANT_ACTIVE_SUBUNITS]);
  } else {
    return A([...ITEM_SUBUNITS_SERVICE_AUTHORIZED_ACTIVE_SUBUNITS]);
  }
}
export function itemSubunitsServiceInactiveSubunits(allForMerchant = false) {
  assert(FETCH_ERROR, HAS_FETCHED);
  if (allForMerchant) {
    return [...ITEM_SUBUNITS_SERVICE_ALL_FOR_MERCHANT_INACTIVE_SUBUNITS];
  } else {
    return [...ITEM_SUBUNITS_SERVICE_AUTHORIZED_INACTIVE_SUBUNITS];
  }
}
export function itemSubunitsServiceAllSubunits(allForMerchant = false) {
  assert(FETCH_ERROR, HAS_FETCHED);
  if (allForMerchant) {
    return [...ITEM_SUBUNITS_SERVICE_ALL_FOR_MERCHANT_ACTIVE_SUBUNITS, ...ITEM_SUBUNITS_SERVICE_ALL_FOR_MERCHANT_INACTIVE_SUBUNITS];
  } else {
    return [...ITEM_SUBUNITS_SERVICE_AUTHORIZED_ACTIVE_SUBUNITS, ...ITEM_SUBUNITS_SERVICE_AUTHORIZED_INACTIVE_SUBUNITS];
  }
}
export function setItemSubunitsServiceMerchantSubunits(merchantSubunits, allForMerchant = false) {
  HAS_FETCHED = true;
  const sortedSubunits = A(merchantSubunits).sortBy('nickname');
  const activeSubunits = sortedSubunits.filter(unit => isNone(unit.unitActive) || unit.unitActive === true);
  const inactiveSubunits = sortedSubunits.filter(unit => !isNone(unit.unitActive) && unit.unitActive === false);
  if (allForMerchant) {
    ITEM_SUBUNITS_SERVICE_ALL_FOR_MERCHANT_ACTIVE_SUBUNITS = activeSubunits;
    ITEM_SUBUNITS_SERVICE_ALL_FOR_MERCHANT_INACTIVE_SUBUNITS = inactiveSubunits;
  } else {
    ITEM_SUBUNITS_SERVICE_AUTHORIZED_ACTIVE_SUBUNITS = activeSubunits;
    ITEM_SUBUNITS_SERVICE_AUTHORIZED_INACTIVE_SUBUNITS = inactiveSubunits;
  }
  return sortedSubunits;
}

// returns either the authorized active units the current user has access to or an empty array
// if the current user has access to all authorized units (Catalog treats an empty array as searching
// accross all units)
export function getAuthorizedUnitsForCatalog() {
  let units = [];

  // passing `false` to `itemSubunitsServiceActiveSubunits` returns only units authorized for the current user.
  const authorizedUnitTokens = A(itemSubunitsServiceActiveSubunits(false)).mapBy('token');
  // passing `true` to `itemSubunitsServiceActiveSubunits` returns all units for the current user, including unauthorized ones.
  const allActiveUnits = A(itemSubunitsServiceActiveSubunits(true)).mapBy('token');
  if (authorizedUnitTokens.length !== allActiveUnits.length) {
    // If the current user is authorized for all units, we don't want to limit the item search to specific units.
    // That way, we can search for all items accross all units, even items that are enabled at 0 units.
    // However if the current user is only authorized for a subset of active units, then we limit to search to only those units.
    units = [...authorizedUnitTokens];
  }
  return units;
}